import { ContactOverviewItem } from '@futrli-sdk/predict';

import { getDateWithStartOfDay } from '../../../../utils/dates';
import { penceToAmount } from '../../../../core/formatters';
import { Data, TABLE_COLUMN, TableFiltersWithSort } from '../../../../utils/table-filters/filter-table-types';

export const getFormattedCustomersAndSuppliersData = (data: ContactOverviewItem[]) => {
  const newData = data.map(d => ({
    ...d,
    last_activity: getDateWithStartOfDay(new Date(d.last_activity)),
    dependence: Math.round(d.dependence * 100),
    total_amount_due: penceToAmount(d.total_amount_due),
    total_amount_overdue: penceToAmount(d.total_amount_overdue),
    total_amount_invoiced: penceToAmount(d.total_amount_invoiced),
    average_sale: penceToAmount(d.average_sale)
  }));

  return newData as Data[];
};

export const getFormattedInitialFilters = (defaultFiltersAndSort: TableFiltersWithSort) => {
  const lastActivityFromDate = defaultFiltersAndSort.filters[TABLE_COLUMN.LAST_ACTIVITY]?.fromDate;
  const lastActivityToDate = defaultFiltersAndSort.filters[TABLE_COLUMN.LAST_ACTIVITY]?.toDate;

  return {
    ...defaultFiltersAndSort.filters,
    [TABLE_COLUMN.LAST_ACTIVITY]: {
      ...defaultFiltersAndSort.filters[TABLE_COLUMN.LAST_ACTIVITY],
      fromDate: lastActivityFromDate ? new Date(lastActivityFromDate) : undefined,
      toDate: lastActivityToDate ? new Date(lastActivityToDate) : undefined
    }
  };
};
